export default "__VITE_ASSET__Bn74ORSP__"